export const GET_ROLES_LIST = "[ROLES] List Get";
export const GET_ROLES_LIST_SUCCESS = "[ROLES] List Get Success";
export const GET_ROLES_LIST_FAIL = "[ROLES] List Get Fail";

export const GET_ROLES_COLLECTION = "[ROLES] Collection Get";
export const GET_ROLES_COLLECTION_SUCCESS = "[ROLES] Collection Get Success";
export const GET_ROLES_COLLECTION_FAIL = "[ROLES] Collection Get Fail";